module.exports = __webpack_public_path__ + "img/traffic.fb43e280.png";